module.exports = __webpack_public_path__ + "img/api.f627c7f7.png";